import { faUserDoctor } from "@fortawesome/pro-duotone-svg-icons";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, IconButton, Typography } from "@mui/material";
import { Doctor } from "../../../interfaces/entities/Doctor";
import './styles.css';
import { sxAddTrustedDoctorsCardContainer, sxDarkGreyBody, sxFormTitle } from "./sxProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";

const AddAllowedDoctorCard: React.FC<{
  doctor: Doctor, handleAddTrustedDoctor: (idPessoa: number) => void
}> = ({ doctor, handleAddTrustedDoctor }) => {

  const accessibility = useAccessibility();

  return (
    <Box 
      sx={sxAddTrustedDoctorsCardContainer} 
      tabIndex={0} style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}
      onClick={() => handleAddTrustedDoctor(parseInt(doctor.idPessoa))}
    >
      <Box display={'flex'} alignItems={'center'} gap={'16px'}>
        <FontAwesomeIcon icon={faUserDoctor} style={{...accessibility.contrastColorAccessibility}} className="fa-icon32x32" />
        <div>
          <Typography style={accessibility.textStyleAccessibility} sx={sxFormTitle}>{doctor.nomePessoa}</Typography>
          <Typography style={accessibility.textStyleAccessibility} sx={sxDarkGreyBody}>{doctor.descrEspec}</Typography>
        </div>
      </Box>
      <IconButton onClick={(e) => { e.stopPropagation(); handleAddTrustedDoctor(parseInt(doctor.idPessoa)) }} aria-label={`adicionar ${doctor.nomePessoa} ${doctor.descrEspec}`}>
        <FontAwesomeIcon style={{...accessibility.contrastColorAccessibility}} icon={faPlus} className="fa-icon-plus20x20" />
      </IconButton>
    </Box>
  )
}

export default AddAllowedDoctorCard;